import type { QueryBoolean } from "../types/settings";

export const kebabize = (s: string) =>
  s.replace(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    ($, ofs) => (ofs ? "-" : "") + $.toLowerCase()
  );

export const camelize = (s: string) =>
  s.replace(/-./g, (x) => x[1].toUpperCase());

export const parseQueryBoolean = (
  x?: QueryBoolean,
  defaultValue = false
): boolean => {
  if (typeof x === "undefined") {
    return defaultValue;
  }

  if (typeof x === "string" && (x === "false" || x === "0")) {
    return false;
  }

  return Boolean(x);
};
